module.exports = __webpack_public_path__ + "assets/img/facergt-app4.3f98e33a.png";